import React, { createContext, useContext, useState, useEffect } from "react";


// const useStateWithCallback = (initialState, callback) => {
//     const storedValue = JSON.parse(localStorage.get("localStorageKey"));
//
//     const [state, setState] = useState(storedValue || initialState);
//
//     useEffect(() => callback(state), [state, callback]);
//
//     return [state, setState];
// };


const useBackedState = (defaultValue, localStorageKey) => {
    const storedValue = JSON.parse(window.localStorage.getItem(localStorageKey))

    const [value, setValue] = useState(
        storedValue === undefined ? defaultValue : storedValue
    );

    const setValueInner = value => {
        if (typeof value === 'function') {
            setValue(v => {
                const newValue = value(v);
                window.localStorage.setItem(localStorageKey, newValue);
                return newValue;
            })
        } else {
            window.localStorage.setItem(localStorageKey, value);
            setValue(value);
        }
    }

    return [value, setValueInner];
}


function useLocalStorage(initialValue, key) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        return initialValue;
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // If error also return initialValue
            console.log(error);
            return initialValue;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = value => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore =
                value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            // A more advanced implementation would handle the error case
            console.log(error);
        }
    };

    return [storedValue, setValue];
}


const PlanViewContext = createContext({
    selectedViewpointId:null,
    setSelectedViewpointId:null,
});


function PlanviewContextProvider(props) {

    const [ selectedViewpointId, setSelectedViewpointId ] = useState(0); // e(0, "Visuelse.SiteViewer.SelectedViewpointId");


    useEffect(() => {

        const storageEvent = (e) => {
            console.log('storageEvent', e);
        };

        window.addEventListener("storage", storageEvent);

        return () => {
            window.removeEventListener("storage", storageEvent);
        };

    }, []);


    return (
        <PlanViewContext.Provider value={{
            selectedViewpointId,
            setSelectedViewpointId,
        }} {...props} />
    );
}


const usePlanViewCtx = () => useContext(PlanViewContext);


export { PlanviewContextProvider, PlanViewContext, usePlanViewCtx };